/**
 * pricingFaq — the /pricing FAQ, ONE source (Oct 10 2026, Nitish + Rhea: every public page gets a .md alternate
 * that says exactly what the page says). Consumers: components/Billing/PricingPage (rendered + FAQPage JSON-LD)
 * and scripts/copyMarketingTwins.js (public/pricing/index.md at prebuild). Cost figures come only from
 * pricingFigures (canon pricing-claims); never type a session figure here.
 */
import { COST_FAQ_ANSWER } from './pricingFigures';

export const PRICING_FAQ = [
  {
    question: 'How do credits work?',
    answer: 'Credits are the currency for AI operations in CellCog. Each AI operation — chat responses, image generation, video creation, document processing — consumes credits. More complex operations use more credits. Credits come from your subscription or one-time top-up purchases.',
  },
  {
    question: 'What does an AI employee cost to run?',
    answer: COST_FAQ_ANSWER,
  },
  {
    question: 'Can I change plans anytime?',
    answer: 'Yes. You pay for the new plan at its full price at checkout, and it starts as soon as the payment goes through. Your previous plan ends at that moment, with no proration or refund for the rest of its period. Credits you already have stay usable until they expire.',
  },
  {
    question: 'What happens when I run out of credits?',
    answer: 'You can purchase additional credits anytime as a one-time top-up (90 credits per $1). Top-up credits are valid for 12 months from purchase. You can also upgrade your plan for more monthly credits.',
  },
  {
    question: 'Do unused credits roll over?',
    answer: 'Subscription credits stay valid for 60 days after your billing period ends, giving you extra time to use them. Monthly plan credits last ~90 days; yearly plan credits last ~14 months. Top-up credits expire 12 months from purchase.',
  },
  {
    question: 'What are the different chat modes?',
    answer: 'You pick two things: which agent, and how deeply it thinks. Agent Mode is fast and iterative — ideal for most tasks. Agent Creative is our most imaginative agent with deep thinking — best for design, frontend, and creative work. Agent Team uses multiple agents for deep, multi-angled research. Each one runs at a tier: Flash for speed, Core for everyday depth, and Max for high-stakes work where the extra quality justifies the extra cost.',
  },
  {
    question: 'Do you offer refunds?',
    answer: 'All payments to CellCog are final and non-refundable, including subscription fees, automatic renewals, and credit top-up purchases. It is your responsibility to cancel before the renewal date if you do not wish to continue. For full details, see our Terms of Service.',
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept all major credit and debit cards through Stripe, including Visa, Mastercard, American Express, and more.',
  },
];
